export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 order-2 lg:order-1">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-5">
              关于刃牙漫画
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                <strong className="text-foreground-900">刃牙漫画在线观看</strong>平台创立于2019年，是中文互联网最早专注于刃牙系列漫画的在线阅读站点之一。我们致力于为广大格斗漫画爱好者提供<strong className="text-foreground-900">刃牙漫画免费在线</strong>的高品质阅读服务。
              </p>
              <p>
                平台收录了<strong className="text-foreground-900">刃牙漫画全集</strong>，涵盖刃牙、刃牙II、范马刃牙、刃牙道等全部篇章，以及烈海王异世界、花山薰外传等番外作品。采用独创的<strong className="text-foreground-900">刃牙漫画下拉式</strong>排版技术，让读者无需频繁翻页，一滑到底畅享沉浸式阅读体验。
              </p>
              <p>
                我们坚持<strong className="text-foreground-900">刃牙漫画在线看</strong>的理念——无需下载任何APP或阅读器，打开浏览器即可流畅阅读刃牙漫画全部章节。目前平台已积累超过58万活跃漫友，每日同步更新最新话。
              </p>
            </div>
          </div>
          <div className="flex-shrink-0 order-1 lg:order-2 w-full max-w-[400px] lg:max-w-[480px]">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20manga%20reading%20atmosphere%2C%20cozy%20Japanese%20style%20room%20with%20manga%20bookshelves%2C%20soft%20warm%20lighting%2C%20comfortable%20ambiance%2C%20wooden%20textures%2C%20no%20text%2C%20inviting%20mood&width=960&height=720&seq=about-01&orientation=landscape"
                alt="刃牙漫画在线观看平台"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}